module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billing-shipping-section"
  }, [(_vm.checkout.billingInfoFields().length > 0) ? _c('div', {
    staticClass: "billing-section custom-fields"
  }, [_c('p', {
    staticClass: "sub-heading",
    style: (_vm.themeColor)
  }, [_vm._v(_vm._s(_vm.getBillingText))]), _vm._v(" "), (_vm.billingNameFields.length == 2) ? _c('div', {
    staticClass: "clearfix double-address-fields"
  }, [_c('text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkout.data[_vm.billingNameFields[0].name]),
      expression: "checkout.data[billingNameFields[0].name]"
    }],
    attrs: {
      "customclass": 'left',
      "config": _vm.billingNameFields[0]
    },
    domProps: {
      "value": (_vm.checkout.data[_vm.billingNameFields[0].name])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.checkout.data,
          $$idx = _vm.billingNameFields[0].name;
        if (!Array.isArray($$exp)) {
          _vm.checkout.data[_vm.billingNameFields[0].name] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _vm._v(" "), _c('text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkout.data[_vm.billingNameFields[1].name]),
      expression: "checkout.data[billingNameFields[1].name]"
    }],
    attrs: {
      "customclass": 'right',
      "config": _vm.billingNameFields[1]
    },
    domProps: {
      "value": (_vm.checkout.data[_vm.billingNameFields[1].name])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.checkout.data,
          $$idx = _vm.billingNameFields[1].name;
        if (!Array.isArray($$exp)) {
          _vm.checkout.data[_vm.billingNameFields[1].name] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.billingNameFields.length == 1) ? _c('text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkout.data[_vm.billingNameFields[0].name]),
      expression: "checkout.data[billingNameFields[0].name]"
    }],
    attrs: {
      "config": _vm.billingNameFields[0]
    },
    domProps: {
      "value": (_vm.checkout.data[_vm.billingNameFields[0].name])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.checkout.data,
          $$idx = _vm.billingNameFields[0].name;
        if (!Array.isArray($$exp)) {
          _vm.checkout.data[_vm.billingNameFields[0].name] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.billingOtherFields), function(field) {
    return [(field.type === 'text') ? _c('text-field', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkout.data[field.name]),
        expression: "checkout.data[field.name]"
      }],
      attrs: {
        "config": field
      },
      domProps: {
        "value": (_vm.checkout.data[field.name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.checkout.data,
            $$idx = field.name;
          if (!Array.isArray($$exp)) {
            _vm.checkout.data[field.name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('address-component', {
    attrs: {
      "fields": _vm.checkout.billingInfoOnlyAddressFields(),
      "values": _vm.checkout.data,
      "label": 'Billing Address'
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.combineShippingAndBilling) ? _c('p', {
    staticClass: "different-shipping"
  }, [_c('span', {
    staticClass: "shipping-text",
    on: {
      "click": function($event) {
        _vm.showShippingBox()
      }
    }
  }, [_vm._v("Use a different address for shipping")])]) : _vm._e(), _vm._v(" "), (!_vm.combineShippingAndBilling && _vm.checkout.shippingInfoFields().length > 0) ? _c('div', {
    staticClass: "shipping-section custom-fields"
  }, [_c('p', {
    staticClass: "sub-heading",
    style: (_vm.themeColor)
  }, [_vm._v("Shipping")]), _vm._v(" "), (_vm.shippingNameFields.length == 2) ? _c('div', {
    staticClass: "clearfix double-address-fields"
  }, [_c('text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkout.data[_vm.shippingNameFields[0].name]),
      expression: "checkout.data[shippingNameFields[0].name]"
    }],
    attrs: {
      "customclass": 'left',
      "config": _vm.shippingNameFields[0]
    },
    domProps: {
      "value": (_vm.checkout.data[_vm.shippingNameFields[0].name])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.checkout.data,
          $$idx = _vm.shippingNameFields[0].name;
        if (!Array.isArray($$exp)) {
          _vm.checkout.data[_vm.shippingNameFields[0].name] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _vm._v(" "), _c('text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkout.data[_vm.shippingNameFields[1].name]),
      expression: "checkout.data[shippingNameFields[1].name]"
    }],
    attrs: {
      "customclass": 'right',
      "config": _vm.shippingNameFields[1]
    },
    domProps: {
      "value": (_vm.checkout.data[_vm.shippingNameFields[1].name])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.checkout.data,
          $$idx = _vm.shippingNameFields[1].name;
        if (!Array.isArray($$exp)) {
          _vm.checkout.data[_vm.shippingNameFields[1].name] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shippingNameFields.length == 1) ? _c('text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkout.data[_vm.shippingNameFields[0].name]),
      expression: "checkout.data[shippingNameFields[0].name]"
    }],
    attrs: {
      "config": _vm.shippingNameFields[0]
    },
    domProps: {
      "value": (_vm.checkout.data[_vm.shippingNameFields[0].name])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.checkout.data,
          $$idx = _vm.shippingNameFields[0].name;
        if (!Array.isArray($$exp)) {
          _vm.checkout.data[_vm.shippingNameFields[0].name] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.shippingOtherFields), function(field) {
    return [(field.type === 'text') ? _c('text-field', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkout.data[field.name]),
        expression: "checkout.data[field.name]"
      }],
      attrs: {
        "config": field
      },
      domProps: {
        "value": (_vm.checkout.data[field.name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.checkout.data,
            $$idx = field.name;
          if (!Array.isArray($$exp)) {
            _vm.checkout.data[field.name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('address-component', {
    attrs: {
      "fields": _vm.checkout.shippingInfoOnlyAddressFields(),
      "values": _vm.checkout.data,
      "label": 'Shipping Address'
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44e44948!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BillingAndShippingInfo.vue
// module id = 76
// module chunks = 0